import React from 'react'
import RadioGroup from './RadioGroup'

type PropTypes = {
  name: string
  value?: boolean
  onComplete: (newValue: boolean) => void
}

export const AbilityForm = ({ name, onComplete, value }: PropTypes) => (
  <div className="signature-modal-vertial-center">
    <div>
      <p
        style={{
          ...styles.title,
          fontWeight: 700,
          fontSize: 16
        }}
      >
        Does {name} have the Ability to sign?
      </p>
      <div style={styles.subLabel}>
        If No, a witness will sign on behalf of {name}
      </div>
      <RadioGroup
        // @ts-ignore
        onChange={onComplete}
        value={value}
        options={[
          {
            label: 'Yes',
            value: true
          },
          {
            label: 'No',
            value: false
          }
        ]}
      />
    </div>
  </div>
)

const styles = {
  title: {
    transition: 'all 0.2s',
    marginBottom: 0
  },
  subLabel: {
    opacity: 0.5,
    fontSize: 12,
    marginBottom: 24
  }
}

export default AbilityForm
